export const iconsBrands = [
  {
    prefix: "fab",
    name: "500px",
  },
  {
    prefix: "fab",
    name: "accessible-icon",
  },
  {
    prefix: "fab",
    name: "accusoft",
  },
  {
    prefix: "fab",
    name: "acquisitions-incorporated",
  },
  {
    prefix: "fab",
    name: "adn",
  },
  {
    prefix: "fab",
    name: "adversal",
  },
  {
    prefix: "fab",
    name: "affiliatetheme",
  },
  {
    prefix: "fab",
    name: "airbnb",
  },
  {
    prefix: "fab",
    name: "algolia",
  },
  {
    prefix: "fab",
    name: "alipay",
  },
  {
    prefix: "fab",
    name: "amazon",
  },
  {
    prefix: "fab",
    name: "amazon-pay",
  },
  {
    prefix: "fab",
    name: "amilia",
  },
  {
    prefix: "fab",
    name: "android",
  },
  {
    prefix: "fab",
    name: "angellist",
  },
  {
    prefix: "fab",
    name: "angrycreative",
  },
  {
    prefix: "fab",
    name: "angular",
  },
  {
    prefix: "fab",
    name: "app-store",
  },
  {
    prefix: "fab",
    name: "app-store-ios",
  },
  {
    prefix: "fab",
    name: "apper",
  },
  {
    prefix: "fab",
    name: "apple",
  },
  {
    prefix: "fab",
    name: "apple-pay",
  },
  {
    prefix: "fab",
    name: "artstation",
  },
  {
    prefix: "fab",
    name: "asymmetrik",
  },
  {
    prefix: "fab",
    name: "atlassian",
  },
  {
    prefix: "fab",
    name: "audible",
  },
  {
    prefix: "fab",
    name: "autoprefixer",
  },
  {
    prefix: "fab",
    name: "avianex",
  },
  {
    prefix: "fab",
    name: "aviato",
  },
  {
    prefix: "fab",
    name: "aws",
  },
  {
    prefix: "fab",
    name: "bandcamp",
  },
  {
    prefix: "fab",
    name: "battle-net",
  },
  {
    prefix: "fab",
    name: "behance",
  },
  {
    prefix: "fab",
    name: "behance-square",
  },
  {
    prefix: "fab",
    name: "bimobject",
  },
  {
    prefix: "fab",
    name: "bitbucket",
  },
  {
    prefix: "fab",
    name: "bitcoin",
  },
  {
    prefix: "fab",
    name: "bity",
  },
  {
    prefix: "fab",
    name: "black-tie",
  },
  {
    prefix: "fab",
    name: "blackberry",
  },
  {
    prefix: "fab",
    name: "blogger",
  },
  {
    prefix: "fab",
    name: "blogger-b",
  },
  {
    prefix: "fab",
    name: "bluetooth",
  },
  {
    prefix: "fab",
    name: "bluetooth-b",
  },
  {
    prefix: "fab",
    name: "bootstrap",
  },
  {
    prefix: "fab",
    name: "btc",
  },
  {
    prefix: "fab",
    name: "buffer",
  },
  {
    prefix: "fab",
    name: "buromobelexperte",
  },
  {
    prefix: "fab",
    name: "buy-n-large",
  },
  {
    prefix: "fab",
    name: "buysellads",
  },
  {
    prefix: "fab",
    name: "canadian-maple-leaf",
  },
  {
    prefix: "fab",
    name: "cc-amazon-pay",
  },
  {
    prefix: "fab",
    name: "cc-amex",
  },
  {
    prefix: "fab",
    name: "cc-apple-pay",
  },
  {
    prefix: "fab",
    name: "cc-diners-club",
  },
  {
    prefix: "fab",
    name: "cc-discover",
  },
  {
    prefix: "fab",
    name: "cc-jcb",
  },
  {
    prefix: "fab",
    name: "cc-mastercard",
  },
  {
    prefix: "fab",
    name: "cc-paypal",
  },
  {
    prefix: "fab",
    name: "cc-stripe",
  },
  {
    prefix: "fab",
    name: "cc-visa",
  },
  {
    prefix: "fab",
    name: "centercode",
  },
  {
    prefix: "fab",
    name: "centos",
  },
  {
    prefix: "fab",
    name: "chrome",
  },
  {
    prefix: "fab",
    name: "chromecast",
  },
  {
    prefix: "fab",
    name: "cloudflare",
  },
  {
    prefix: "fab",
    name: "cloudscale",
  },
  {
    prefix: "fab",
    name: "cloudsmith",
  },
  {
    prefix: "fab",
    name: "cloudversify",
  },
  {
    prefix: "fab",
    name: "codepen",
  },
  {
    prefix: "fab",
    name: "codiepie",
  },
  {
    prefix: "fab",
    name: "confluence",
  },
  {
    prefix: "fab",
    name: "connectdevelop",
  },
  {
    prefix: "fab",
    name: "contao",
  },
  {
    prefix: "fab",
    name: "cotton-bureau",
  },
  {
    prefix: "fab",
    name: "cpanel",
  },
  {
    prefix: "fab",
    name: "creative-commons",
  },
  {
    prefix: "fab",
    name: "creative-commons-by",
  },
  {
    prefix: "fab",
    name: "creative-commons-nc",
  },
  {
    prefix: "fab",
    name: "creative-commons-nc-eu",
  },
  {
    prefix: "fab",
    name: "creative-commons-nc-jp",
  },
  {
    prefix: "fab",
    name: "creative-commons-nd",
  },
  {
    prefix: "fab",
    name: "creative-commons-pd",
  },
  {
    prefix: "fab",
    name: "creative-commons-pd-alt",
  },
  {
    prefix: "fab",
    name: "creative-commons-remix",
  },
  {
    prefix: "fab",
    name: "creative-commons-sa",
  },
  {
    prefix: "fab",
    name: "creative-commons-sampling",
  },
  {
    prefix: "fab",
    name: "creative-commons-sampling-plus",
  },
  {
    prefix: "fab",
    name: "creative-commons-share",
  },
  {
    prefix: "fab",
    name: "creative-commons-zero",
  },
  {
    prefix: "fab",
    name: "critical-role",
  },
  {
    prefix: "fab",
    name: "css3",
  },
  {
    prefix: "fab",
    name: "css3-alt",
  },
  {
    prefix: "fab",
    name: "cuttlefish",
  },
  {
    prefix: "fab",
    name: "d-and-d",
  },
  {
    prefix: "fab",
    name: "d-and-d-beyond",
  },
  {
    prefix: "fab",
    name: "dailymotion",
  },
  {
    prefix: "fab",
    name: "dashcube",
  },
  {
    prefix: "fab",
    name: "deezer",
  },
  {
    prefix: "fab",
    name: "delicious",
  },
  {
    prefix: "fab",
    name: "deploydog",
  },
  {
    prefix: "fab",
    name: "deskpro",
  },
  {
    prefix: "fab",
    name: "dev",
  },
  {
    prefix: "fab",
    name: "deviantart",
  },
  {
    prefix: "fab",
    name: "dhl",
  },
  {
    prefix: "fab",
    name: "diaspora",
  },
  {
    prefix: "fab",
    name: "digg",
  },
  {
    prefix: "fab",
    name: "digital-ocean",
  },
  {
    prefix: "fab",
    name: "discord",
  },
  {
    prefix: "fab",
    name: "discourse",
  },
  {
    prefix: "fab",
    name: "dochub",
  },
  {
    prefix: "fab",
    name: "docker",
  },
  {
    prefix: "fab",
    name: "draft2digital",
  },
  {
    prefix: "fab",
    name: "dribbble",
  },
  {
    prefix: "fab",
    name: "dribbble-square",
  },
  {
    prefix: "fab",
    name: "dropbox",
  },
  {
    prefix: "fab",
    name: "drupal",
  },
  {
    prefix: "fab",
    name: "dyalog",
  },
  {
    prefix: "fab",
    name: "earlybirds",
  },
  {
    prefix: "fab",
    name: "ebay",
  },
  {
    prefix: "fab",
    name: "edge",
  },
  {
    prefix: "fab",
    name: "edge-legacy",
  },
  {
    prefix: "fab",
    name: "elementor",
  },
  {
    prefix: "fab",
    name: "ello",
  },
  {
    prefix: "fab",
    name: "ember",
  },
  {
    prefix: "fab",
    name: "empire",
  },
  {
    prefix: "fab",
    name: "envira",
  },
  {
    prefix: "fab",
    name: "erlang",
  },
  {
    prefix: "fab",
    name: "ethereum",
  },
  {
    prefix: "fab",
    name: "etsy",
  },
  {
    prefix: "fab",
    name: "evernote",
  },
  {
    prefix: "fab",
    name: "expeditedssl",
  },
  {
    prefix: "fab",
    name: "facebook",
  },
  {
    prefix: "fab",
    name: "facebook-f",
  },
  {
    prefix: "fab",
    name: "facebook-messenger",
  },
  {
    prefix: "fab",
    name: "facebook-square",
  },
  {
    prefix: "fab",
    name: "fantasy-flight-games",
  },
  {
    prefix: "fab",
    name: "fedex",
  },
  {
    prefix: "fab",
    name: "fedora",
  },
  {
    prefix: "fab",
    name: "figma",
  },
  {
    prefix: "fab",
    name: "firefox",
  },
  {
    prefix: "fab",
    name: "firefox-browser",
  },
  {
    prefix: "fab",
    name: "first-order",
  },
  {
    prefix: "fab",
    name: "first-order-alt",
  },
  {
    prefix: "fab",
    name: "firstdraft",
  },
  {
    prefix: "fab",
    name: "flickr",
  },
  {
    prefix: "fab",
    name: "flipboard",
  },
  {
    prefix: "fab",
    name: "fly",
  },
  {
    prefix: "fab",
    name: "font-awesome",
  },
  {
    prefix: "fab",
    name: "font-awesome-alt",
  },
  {
    prefix: "fab",
    name: "font-awesome-flag",
  },
  {
    prefix: "fab",
    name: "fonticons",
  },
  {
    prefix: "fab",
    name: "fonticons-fi",
  },
  {
    prefix: "fab",
    name: "fort-awesome",
  },
  {
    prefix: "fab",
    name: "fort-awesome-alt",
  },
  {
    prefix: "fab",
    name: "forumbee",
  },
  {
    prefix: "fab",
    name: "foursquare",
  },
  {
    prefix: "fab",
    name: "free-code-camp",
  },
  {
    prefix: "fab",
    name: "freebsd",
  },
  {
    prefix: "fab",
    name: "fulcrum",
  },
  {
    prefix: "fab",
    name: "galactic-republic",
  },
  {
    prefix: "fab",
    name: "galactic-senate",
  },
  {
    prefix: "fab",
    name: "get-pocket",
  },
  {
    prefix: "fab",
    name: "gg",
  },
  {
    prefix: "fab",
    name: "gg-circle",
  },
  {
    prefix: "fab",
    name: "git",
  },
  {
    prefix: "fab",
    name: "git-alt",
  },
  {
    prefix: "fab",
    name: "git-square",
  },
  {
    prefix: "fab",
    name: "github",
  },
  {
    prefix: "fab",
    name: "github-alt",
  },
  {
    prefix: "fab",
    name: "github-square",
  },
  {
    prefix: "fab",
    name: "gitkraken",
  },
  {
    prefix: "fab",
    name: "gitlab",
  },
  {
    prefix: "fab",
    name: "gitter",
  },
  {
    prefix: "fab",
    name: "glide",
  },
  {
    prefix: "fab",
    name: "glide-g",
  },
  {
    prefix: "fab",
    name: "gofore",
  },
  {
    prefix: "fab",
    name: "goodreads",
  },
  {
    prefix: "fab",
    name: "goodreads-g",
  },
  {
    prefix: "fab",
    name: "google",
  },
  {
    prefix: "fab",
    name: "google-drive",
  },
  {
    prefix: "fab",
    name: "google-pay",
  },
  {
    prefix: "fab",
    name: "google-play",
  },
  {
    prefix: "fab",
    name: "google-plus",
  },
  {
    prefix: "fab",
    name: "google-plus-g",
  },
  {
    prefix: "fab",
    name: "google-plus-square",
  },
  {
    prefix: "fab",
    name: "google-wallet",
  },
  {
    prefix: "fab",
    name: "gratipay",
  },
  {
    prefix: "fab",
    name: "grav",
  },
  {
    prefix: "fab",
    name: "gripfire",
  },
  {
    prefix: "fab",
    name: "grunt",
  },
  {
    prefix: "fab",
    name: "guilded",
  },
  {
    prefix: "fab",
    name: "gulp",
  },
  {
    prefix: "fab",
    name: "hacker-news",
  },
  {
    prefix: "fab",
    name: "hacker-news-square",
  },
  {
    prefix: "fab",
    name: "hackerrank",
  },
  {
    prefix: "fab",
    name: "hips",
  },
  {
    prefix: "fab",
    name: "hire-a-helper",
  },
  {
    prefix: "fab",
    name: "hive",
  },
  {
    prefix: "fab",
    name: "hooli",
  },
  {
    prefix: "fab",
    name: "hornbill",
  },
  {
    prefix: "fab",
    name: "hotjar",
  },
  {
    prefix: "fab",
    name: "houzz",
  },
  {
    prefix: "fab",
    name: "html5",
  },
  {
    prefix: "fab",
    name: "hubspot",
  },
  {
    prefix: "fab",
    name: "ideal",
  },
  {
    prefix: "fab",
    name: "imdb",
  },
  {
    prefix: "fab",
    name: "innosoft",
  },
  {
    prefix: "fab",
    name: "instagram",
  },
  {
    prefix: "fab",
    name: "instagram-square",
  },
  {
    prefix: "fab",
    name: "instalod",
  },
  {
    prefix: "fab",
    name: "intercom",
  },
  {
    prefix: "fab",
    name: "internet-explorer",
  },
  {
    prefix: "fab",
    name: "invision",
  },
  {
    prefix: "fab",
    name: "ioxhost",
  },
  {
    prefix: "fab",
    name: "itch-io",
  },
  {
    prefix: "fab",
    name: "itunes",
  },
  {
    prefix: "fab",
    name: "itunes-note",
  },
  {
    prefix: "fab",
    name: "java",
  },
  {
    prefix: "fab",
    name: "jedi-order",
  },
  {
    prefix: "fab",
    name: "jenkins",
  },
  {
    prefix: "fab",
    name: "jira",
  },
  {
    prefix: "fab",
    name: "joget",
  },
  {
    prefix: "fab",
    name: "joomla",
  },
  {
    prefix: "fab",
    name: "js",
  },
  {
    prefix: "fab",
    name: "js-square",
  },
  {
    prefix: "fab",
    name: "jsfiddle",
  },
  {
    prefix: "fab",
    name: "kaggle",
  },
  {
    prefix: "fab",
    name: "keybase",
  },
  {
    prefix: "fab",
    name: "keycdn",
  },
  {
    prefix: "fab",
    name: "kickstarter",
  },
  {
    prefix: "fab",
    name: "kickstarter-k",
  },
  {
    prefix: "fab",
    name: "korvue",
  },
  {
    prefix: "fab",
    name: "laravel",
  },
  {
    prefix: "fab",
    name: "lastfm",
  },
  {
    prefix: "fab",
    name: "lastfm-square",
  },
  {
    prefix: "fab",
    name: "leanpub",
  },
  {
    prefix: "fab",
    name: "less",
  },
  {
    prefix: "fab",
    name: "line",
  },
  {
    prefix: "fab",
    name: "linkedin",
  },
  {
    prefix: "fab",
    name: "linkedin-in",
  },
  {
    prefix: "fab",
    name: "linode",
  },
  {
    prefix: "fab",
    name: "linux",
  },
  {
    prefix: "fab",
    name: "lyft",
  },
  {
    prefix: "fab",
    name: "magento",
  },
  {
    prefix: "fab",
    name: "mailchimp",
  },
  {
    prefix: "fab",
    name: "mandalorian",
  },
  {
    prefix: "fab",
    name: "markdown",
  },
  {
    prefix: "fab",
    name: "mastodon",
  },
  {
    prefix: "fab",
    name: "maxcdn",
  },
  {
    prefix: "fab",
    name: "mdb",
  },
  {
    prefix: "fab",
    name: "medapps",
  },
  {
    prefix: "fab",
    name: "medium",
  },
  {
    prefix: "fab",
    name: "medium-m",
  },
  {
    prefix: "fab",
    name: "medrt",
  },
  {
    prefix: "fab",
    name: "meetup",
  },
  {
    prefix: "fab",
    name: "megaport",
  },
  {
    prefix: "fab",
    name: "mendeley",
  },
  {
    prefix: "fab",
    name: "microblog",
  },
  {
    prefix: "fab",
    name: "microsoft",
  },
  {
    prefix: "fab",
    name: "mix",
  },
  {
    prefix: "fab",
    name: "mixcloud",
  },
  {
    prefix: "fab",
    name: "mixer",
  },
  {
    prefix: "fab",
    name: "mizuni",
  },
  {
    prefix: "fab",
    name: "modx",
  },
  {
    prefix: "fab",
    name: "monero",
  },
  {
    prefix: "fab",
    name: "napster",
  },
  {
    prefix: "fab",
    name: "neos",
  },
  {
    prefix: "fab",
    name: "nimblr",
  },
  {
    prefix: "fab",
    name: "node",
  },
  {
    prefix: "fab",
    name: "node-js",
  },
  {
    prefix: "fab",
    name: "npm",
  },
  {
    prefix: "fab",
    name: "ns8",
  },
  {
    prefix: "fab",
    name: "nutritionix",
  },
  {
    prefix: "fab",
    name: "octopus-deploy",
  },
  {
    prefix: "fab",
    name: "odnoklassniki",
  },
  {
    prefix: "fab",
    name: "odnoklassniki-square",
  },
  {
    prefix: "fab",
    name: "old-republic",
  },
  {
    prefix: "fab",
    name: "opencart",
  },
  {
    prefix: "fab",
    name: "openid",
  },
  {
    prefix: "fab",
    name: "opera",
  },
  {
    prefix: "fab",
    name: "optin-monster",
  },
  {
    prefix: "fab",
    name: "orcid",
  },
  {
    prefix: "fab",
    name: "osi",
  },
  {
    prefix: "fab",
    name: "page4",
  },
  {
    prefix: "fab",
    name: "pagelines",
  },
  {
    prefix: "fab",
    name: "palfed",
  },
  {
    prefix: "fab",
    name: "patreon",
  },
  {
    prefix: "fab",
    name: "paypal",
  },
  {
    prefix: "fab",
    name: "penny-arcade",
  },
  {
    prefix: "fab",
    name: "perbyte",
  },
  {
    prefix: "fab",
    name: "periscope",
  },
  {
    prefix: "fab",
    name: "phabricator",
  },
  {
    prefix: "fab",
    name: "phoenix-framework",
  },
  {
    prefix: "fab",
    name: "phoenix-squadron",
  },
  {
    prefix: "fab",
    name: "php",
  },
  {
    prefix: "fab",
    name: "pied-piper",
  },
  {
    prefix: "fab",
    name: "pied-piper-alt",
  },
  {
    prefix: "fab",
    name: "pied-piper-hat",
  },
  {
    prefix: "fab",
    name: "pied-piper-pp",
  },
  {
    prefix: "fab",
    name: "pied-piper-square",
  },
  {
    prefix: "fab",
    name: "pinterest",
  },
  {
    prefix: "fab",
    name: "pinterest-p",
  },
  {
    prefix: "fab",
    name: "pinterest-square",
  },
  {
    prefix: "fab",
    name: "playstation",
  },
  {
    prefix: "fab",
    name: "product-hunt",
  },
  {
    prefix: "fab",
    name: "pushed",
  },
  {
    prefix: "fab",
    name: "python",
  },
  {
    prefix: "fab",
    name: "qq",
  },
  {
    prefix: "fab",
    name: "quinscape",
  },
  {
    prefix: "fab",
    name: "quora",
  },
  {
    prefix: "fab",
    name: "r-project",
  },
  {
    prefix: "fab",
    name: "raspberry-pi",
  },
  {
    prefix: "fab",
    name: "ravelry",
  },
  {
    prefix: "fab",
    name: "react",
  },
  {
    prefix: "fab",
    name: "reacteurope",
  },
  {
    prefix: "fab",
    name: "readme",
  },
  {
    prefix: "fab",
    name: "rebel",
  },
  {
    prefix: "fab",
    name: "red-river",
  },
  {
    prefix: "fab",
    name: "reddit",
  },
  {
    prefix: "fab",
    name: "reddit-alien",
  },
  {
    prefix: "fab",
    name: "reddit-square",
  },
  {
    prefix: "fab",
    name: "redhat",
  },
  {
    prefix: "fab",
    name: "renren",
  },
  {
    prefix: "fab",
    name: "replyd",
  },
  {
    prefix: "fab",
    name: "researchgate",
  },
  {
    prefix: "fab",
    name: "resolving",
  },
  {
    prefix: "fab",
    name: "rev",
  },
  {
    prefix: "fab",
    name: "rocketchat",
  },
  {
    prefix: "fab",
    name: "rockrms",
  },
  {
    prefix: "fab",
    name: "rust",
  },
  {
    prefix: "fab",
    name: "safari",
  },
  {
    prefix: "fab",
    name: "salesforce",
  },
  {
    prefix: "fab",
    name: "sass",
  },
  {
    prefix: "fab",
    name: "schlix",
  },
  {
    prefix: "fab",
    name: "scribd",
  },
  {
    prefix: "fab",
    name: "searchengin",
  },
  {
    prefix: "fab",
    name: "sellcast",
  },
  {
    prefix: "fab",
    name: "sellsy",
  },
  {
    prefix: "fab",
    name: "servicestack",
  },
  {
    prefix: "fab",
    name: "shirtsinbulk",
  },
  {
    prefix: "fab",
    name: "shopify",
  },
  {
    prefix: "fab",
    name: "shopware",
  },
  {
    prefix: "fab",
    name: "simplybuilt",
  },
  {
    prefix: "fab",
    name: "sistrix",
  },
  {
    prefix: "fab",
    name: "sith",
  },
  {
    prefix: "fab",
    name: "sketch",
  },
  {
    prefix: "fab",
    name: "skyatlas",
  },
  {
    prefix: "fab",
    name: "skype",
  },
  {
    prefix: "fab",
    name: "slack",
  },
  {
    prefix: "fab",
    name: "slack-hash",
  },
  {
    prefix: "fab",
    name: "slideshare",
  },
  {
    prefix: "fab",
    name: "snapchat",
  },
  {
    prefix: "fab",
    name: "snapchat-ghost",
  },
  {
    prefix: "fab",
    name: "snapchat-square",
  },
  {
    prefix: "fab",
    name: "soundcloud",
  },
  {
    prefix: "fab",
    name: "sourcetree",
  },
  {
    prefix: "fab",
    name: "speakap",
  },
  {
    prefix: "fab",
    name: "speaker-deck",
  },
  {
    prefix: "fab",
    name: "spotify",
  },
  {
    prefix: "fab",
    name: "squarespace",
  },
  {
    prefix: "fab",
    name: "stack-exchange",
  },
  {
    prefix: "fab",
    name: "stack-overflow",
  },
  {
    prefix: "fab",
    name: "stackpath",
  },
  {
    prefix: "fab",
    name: "staylinked",
  },
  {
    prefix: "fab",
    name: "steam",
  },
  {
    prefix: "fab",
    name: "steam-square",
  },
  {
    prefix: "fab",
    name: "steam-symbol",
  },
  {
    prefix: "fab",
    name: "sticker-mule",
  },
  {
    prefix: "fab",
    name: "strava",
  },
  {
    prefix: "fab",
    name: "stripe",
  },
  {
    prefix: "fab",
    name: "stripe-s",
  },
  {
    prefix: "fab",
    name: "studiovinari",
  },
  {
    prefix: "fab",
    name: "stumbleupon",
  },
  {
    prefix: "fab",
    name: "stumbleupon-circle",
  },
  {
    prefix: "fab",
    name: "superpowers",
  },
  {
    prefix: "fab",
    name: "supple",
  },
  {
    prefix: "fab",
    name: "suse",
  },
  {
    prefix: "fab",
    name: "swift",
  },
  {
    prefix: "fab",
    name: "symfony",
  },
  {
    prefix: "fab",
    name: "teamspeak",
  },
  {
    prefix: "fab",
    name: "telegram",
  },
  {
    prefix: "fab",
    name: "telegram-plane",
  },
  {
    prefix: "fab",
    name: "tencent-weibo",
  },
  {
    prefix: "fab",
    name: "the-red-yeti",
  },
  {
    prefix: "fab",
    name: "themeco",
  },
  {
    prefix: "fab",
    name: "themeisle",
  },
  {
    prefix: "fab",
    name: "think-peaks",
  },
  {
    prefix: "fab",
    name: "tiktok",
  },
  {
    prefix: "fab",
    name: "trade-federation",
  },
  {
    prefix: "fab",
    name: "trello",
  },
  {
    prefix: "fab",
    name: "tumblr",
  },
  {
    prefix: "fab",
    name: "tumblr-square",
  },
  {
    prefix: "fab",
    name: "twitch",
  },
  {
    prefix: "fab",
    name: "twitter",
  },
  {
    prefix: "fab",
    name: "twitter-square",
  },
  {
    prefix: "fab",
    name: "typo3",
  },
  {
    prefix: "fab",
    name: "uber",
  },
  {
    prefix: "fab",
    name: "ubuntu",
  },
  {
    prefix: "fab",
    name: "uikit",
  },
  {
    prefix: "fab",
    name: "umbraco",
  },
  {
    prefix: "fab",
    name: "uncharted",
  },
  {
    prefix: "fab",
    name: "uniregistry",
  },
  {
    prefix: "fab",
    name: "unity",
  },
  {
    prefix: "fab",
    name: "unsplash",
  },
  {
    prefix: "fab",
    name: "untappd",
  },
  {
    prefix: "fab",
    name: "ups",
  },
  {
    prefix: "fab",
    name: "usb",
  },
  {
    prefix: "fab",
    name: "usps",
  },
  {
    prefix: "fab",
    name: "ussunnah",
  },
  {
    prefix: "fab",
    name: "vaadin",
  },
  {
    prefix: "fab",
    name: "viacoin",
  },
  {
    prefix: "fab",
    name: "viadeo",
  },
  {
    prefix: "fab",
    name: "viadeo-square",
  },
  {
    prefix: "fab",
    name: "viber",
  },
  {
    prefix: "fab",
    name: "vimeo",
  },
  {
    prefix: "fab",
    name: "vimeo-square",
  },
  {
    prefix: "fab",
    name: "vimeo-v",
  },
  {
    prefix: "fab",
    name: "vine",
  },
  {
    prefix: "fab",
    name: "vk",
  },
  {
    prefix: "fab",
    name: "vnv",
  },
  {
    prefix: "fab",
    name: "vuejs",
  },
  {
    prefix: "fab",
    name: "watchman-monitoring",
  },
  {
    prefix: "fab",
    name: "waze",
  },
  {
    prefix: "fab",
    name: "weebly",
  },
  {
    prefix: "fab",
    name: "weibo",
  },
  {
    prefix: "fab",
    name: "weixin",
  },
  {
    prefix: "fab",
    name: "whatsapp",
  },
  {
    prefix: "fab",
    name: "whatsapp-square",
  },
  {
    prefix: "fab",
    name: "whmcs",
  },
  {
    prefix: "fab",
    name: "wikipedia-w",
  },
  {
    prefix: "fab",
    name: "windows",
  },
  {
    prefix: "fab",
    name: "wix",
  },
  {
    prefix: "fab",
    name: "wizards-of-the-coast",
  },
  {
    prefix: "fab",
    name: "wodu",
  },
  {
    prefix: "fab",
    name: "wolf-pack-battalion",
  },
  {
    prefix: "fab",
    name: "wordpress",
  },
  {
    prefix: "fab",
    name: "wordpress-simple",
  },
  {
    prefix: "fab",
    name: "wpbeginner",
  },
  {
    prefix: "fab",
    name: "wpexplorer",
  },
  {
    prefix: "fab",
    name: "wpforms",
  },
  {
    prefix: "fab",
    name: "wpressr",
  },
  {
    prefix: "fab",
    name: "xbox",
  },
  {
    prefix: "fab",
    name: "xing",
  },
  {
    prefix: "fab",
    name: "xing-square",
  },
  {
    prefix: "fab",
    name: "y-combinator",
  },
  {
    prefix: "fab",
    name: "yahoo",
  },
  {
    prefix: "fab",
    name: "yammer",
  },
  {
    prefix: "fab",
    name: "yandex",
  },
  {
    prefix: "fab",
    name: "yandex-international",
  },
  {
    prefix: "fab",
    name: "yarn",
  },
  {
    prefix: "fab",
    name: "yelp",
  },
  {
    prefix: "fab",
    name: "yoast",
  },
  {
    prefix: "fab",
    name: "youtube",
  },
  {
    prefix: "fab",
    name: "youtube-square",
  },
  {
    prefix: "fab",
    name: "zhihu",
  },
];
